import useAccidents from "./useAccidents";
import {
  islandTypes,
  accidentTypes,
  getAccidentOptionLabel,
} from "layouts/dataimport/accidents/options";

const useAccidentsTable = (counter) => {
  const { data, loading, error } = useAccidents(counter);

  const columns = [
    { Header: "Id", accessor: "id" },
    { Header: "Νησί", accessor: "island" },
    { Header: "Ημερομηνία", accessor: "date" },
    { Header: "Τύπος ατυχήματος", accessor: "type_accident" },
    { Header: "Αναγνωριστικός Αριθμός Τροχαίας", accessor: "police_report_number" },
  ];

  const rows = data.map((item) => ({
    id: item.id ?? "Unknown",
    island: getAccidentOptionLabel(islandTypes, item.island) || "Unknown",
    date: item.date || "Unknown",
    type_accident: getAccidentOptionLabel(accidentTypes, item.type_accident) || "Unknown",
    police_report_number: item.police_report || "Unknown",
  }));

  return {
    tableData: { columns, rows },
    loading,
    error,
  };
};

export default useAccidentsTable;
